/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { NodeRecordTypeMap } from '../../../backendModels/records.model';
import { InputState } from '../../../backendModels/general.model';
import { TextFieldValue } from '../../../backendModels/generic-element.model';
import { MultiSelectFieldValueTyped, SingleSelectFieldValueTyped } from '../../generic';
import { NumericFieldValue } from '../../../backendModels/generic-element.model';

export enum DefibrillationKeys {
  defibrillationaed = 'DEFIBRILLATION_AED',
  defibrillationdefi = 'DEFIBRILLATION_DEFI',
  defibrillationerstanwendunglaien = 'DEFIBRILLATION_ERSTANWENDUNG_LAIEN',
  defibrillationerstanwendungfirstresponder = 'DEFIBRILLATION_ERSTANWENDUNG_FIRST_RESPONDER',
  defibrillationerstanwendungrd = 'DEFIBRILLATION_ERSTANWENDUNG_RD',
  defibrillationerstanwendungarzt = 'DEFIBRILLATION_ERSTANWENDUNG_ARZT',
  defibrillationimpulstypmono = 'DEFIBRILLATION_IMPULS_TYP_MONO',
  defibrillationimpulstypbi = 'DEFIBRILLATION_IMPULS_TYP_BI',
}

export const DEFIBRILLATION_RECORD_ELEMENT_KEY = 'defibrillation';

export type DefibrillationRecord = NodeRecordTypeMap['generic'] &
  (
    | {
        readonly elementKey: typeof DEFIBRILLATION_RECORD_ELEMENT_KEY;
        readonly inputState: InputState.ENTERED;
        readonly values: {
          defibrillationTyp?: MultiSelectFieldValueTyped<DefibrillationKeys>;
          defibrillationErstanwendung?: SingleSelectFieldValueTyped<DefibrillationKeys>;
          defibrillationImpulsTyp?: SingleSelectFieldValueTyped<DefibrillationKeys>;
          defibrillationErsterSchock?: TextFieldValue;
          defibrillationErsterRosc?: TextFieldValue;
          defibrillationAnzahlSchocks?: NumericFieldValue;
          defibrillationMaxEnergie?: NumericFieldValue;
        };
      }
    | {
        readonly inputState: InputState.UNKNOWN;
        readonly values: null;
      }
  );

export const defibrillationLabels: Record<DefibrillationKeys, string> = {
  [DefibrillationKeys.defibrillationaed]: 'AED',
  [DefibrillationKeys.defibrillationdefi]: 'Defi',
  [DefibrillationKeys.defibrillationerstanwendunglaien]: 'Laien',
  [DefibrillationKeys.defibrillationerstanwendungfirstresponder]: 'First Responder',
  [DefibrillationKeys.defibrillationerstanwendungrd]: 'Rettungsdienst',
  [DefibrillationKeys.defibrillationerstanwendungarzt]: 'Arzt',
  [DefibrillationKeys.defibrillationimpulstypmono]: 'monophasisch',
  [DefibrillationKeys.defibrillationimpulstypbi]: 'biphasisch',
};

export function getDefibrillationTuple(key: DefibrillationKeys): [DefibrillationKeys, string] {
  return [key, defibrillationLabels[key]];
}

export function getDefibrillationTuplesFor(keys: DefibrillationKeys[]): [DefibrillationKeys, string][] {
  return keys.map((k) => {
    return getDefibrillationTuple(k);
  });
}
